export default __webpack_public_path__ + "static/media/LocationTypeIcon.3ed66aa7.svg";